function languageSelector(){
    const forms = window.document.querySelectorAll('[class*=CompactLanguageSwicther-]');
    const options = window.document.querySelectorAll('.js_locale-code');
    if (options.length < 1) return;

    options.forEach(option => {
        option.addEventListener('click',function(e){
            e.preventDefault();
            const form = option.closest('form');
            const selectLang = form?.querySelector('[id*=CompactLanguageCode-]');
            selectLang.value = option.getAttribute('lang');
            form?.submit();
        })
    });
}
window.addEventListener('load',languageSelector);